<template>
    <div class="section">
        <b-field v-for="field in fields" :key="field.id" :label="field.title">
            <b-input v-if="field.fieldType == 'input'" @input="handleInput(field, $event)">

            </b-input>
            <b-select v-else-if="field.fieldType == 'select'" @change.native="handleInput(field, $event.target.value)" expanded>
                <option v-for="opt in field.optionsList" :key="opt.id" :value="opt.id" >
                    {{opt.title}}
                </option>
            </b-select>

            <b-switch v-else-if="field.fieldType == 'checkbox'" @input="handleInput(field, $event)"></b-switch>
        </b-field>

        <div class="m-t-10 has-text-centered">
            <b-button
            type="is-custom"
            rounded
            :disabled="isDisabledButton"
            @click="continueStep">
                Continuar a confirmacion
                <b-icon icon="arrow-right" size="is-small"></b-icon>
            </b-button>
        </div>

    </div>
</template>

<script>
export default {
    props:{
        fields:{
            type:Array,
            default: new Array([])
        }
    },
    data(){
        return{
            inputList:[]
        }
    },
    computed:{
        isDisabledButton(){
            return this.fields.length != this.inputList.length
        }
    },
    methods:{
        handleInput(field, value){
            var index = this.inputList.findIndex(item=>{
                return item.customField == field.id 
            })
            var element = this.inputList[index]
            if (element != undefined){
                if (field.fieldType == 'input' || field.fieldType == 'checkbox'){
                    if (value.length){
                        this.inputList[index].title = String(value)
                    }else{
                        this.inputList.splice(index, 1)
                    }
                }
                else if (field.fieldType == 'select'){
                    var option = field.optionsList.find(
                        el=>{
                            return el.id == value
                        }
                    )
                    this.inputList[index].title = option.title
                    this.inputList[index].customFieldOption = value
                }
            } else{
                if (field.fieldType == 'input' || field.fieldType == 'checkbox'){
                    this.inputList.push({
                        customField: field.id,
                        title: String(value)
                    })
                }
                else if (field.fieldType == 'select'){
                    var option = field.optionsList.find(
                        el=>{
                            return el.id == value
                        }
                    )
                    
                    this.inputList.push({
                        customField: field.id,
                        customFieldOption: value,
                        title: option.title
                    })
                }
                
            }
            
        },
        continueStep(){
            this.$emit('customData', this.inputList)
        }
    }
}
</script>

<style lang="scss" scoped>
.is-custom-color{
    color:var(--primary);
}
.is-custom{
    color:var(--text-color);
    background:var(--primary);
}
</style>